import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';

const idSchema = z.coerce.number().int().positive().optional().catch(undefined);

const costoEfectividadSearchSchema = z.object({
  diagnosticoId: idSchema,
  tecnologia: z.string().trim().min(1).max(200).optional().catch(undefined),
  paisId: idSchema,
  anioPublicacion: z.coerce.number().int().min(1900).max(2100).optional().catch(undefined),
  endpointTipoId: idSchema,
  dominancia: z.enum(['DOMINANTE', 'DOMINADO', 'NINGUNA']).optional().catch(undefined),
});

export const Route = createFileRoute('/admin/recet/costo-efectividad')({
  validateSearch: costoEfectividadSearchSchema,
  pendingComponent: PageSkeleton,
});
